import React from "react";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

const content = {
  mentions: { title: "Mentions légales", body: [
    "Éditeur du site : NJ Conciergerie — 22 boulevard de la Marne, 76000 Rouen.",
    "Téléphone : 06 66 93 42 67. Email : contact@laconciergerierouen.com.",
    "Directeur de la publication : NJ Conciergerie.",
    "Hébergement : les données sont hébergées de manière sécurisée. Le site est accessible via https://www.laconciergerierouen.com.",
    "Propriété intellectuelle : l'ensemble des contenus (textes, photographies, logos) est la propriété de NJ Conciergerie et ne peut être reproduit sans autorisation.",
  ]},
  privacy: { title: "Politique de confidentialité", body: [
    "NJ Conciergerie collecte uniquement les données nécessaires au traitement des réservations et demandes (nom, email, téléphone, adresse).",
    "Vos données ne sont jamais revendues à des tiers. Les paiements sont traités de manière sécurisée par Stripe ; aucune donnée bancaire n'est stockée sur nos serveurs.",
    "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données en écrivant à contact@laconciergerierouen.com.",
    "Les données de réservation sont conservées pendant la durée légale requise.",
  ]},
  cgv: { title: "Conditions générales de vente", body: [
    "Les présentes CGV régissent les réservations directes effectuées sur le site de NJ Conciergerie.",
    "Horaires : arrivée à partir de 17h00, départ au plus tard à 10h00. Des options d'arrivée anticipée et de départ tardif sont proposées selon disponibilité.",
    "Une réservation n'est confirmée qu'après validation complète du paiement.",
    "Conditions d'annulation : elles dépendent du logement (flexible, modérée, stricte ou personnalisée) et sont affichées avant paiement. Le montant remboursé est calculé automatiquement selon le délai avant l'arrivée.",
    "Taxe de séjour : la taxe de séjour applicable est ajoutée au montant total lorsque requise.",
  ]},
  cookies: { title: "Politique de cookies", body: [
    "Le site utilise des cookies strictement nécessaires à son fonctionnement ainsi que des cookies de mesure d'audience.",
    "Vous pouvez accepter ou refuser les cookies via la bannière de consentement.",
    "Vous pouvez à tout moment modifier vos préférences depuis les paramètres de votre navigateur.",
  ]},
};

export default function Legal({ type }) {
  const c = content[type] || content.mentions;
  const canon = { mentions: "/mentions-legales", privacy: "/confidentialite", cgv: "/cgv", cookies: "/cookies" }[type] || "/mentions-legales";
  return (
    <Layout>
      <Seo title={`${c.title} | NJ Conciergerie`} description={`${c.title} de NJ Conciergerie, conciergerie et location courte durée à Rouen.`} canonical={canon} noindex />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-serif font-light text-4xl text-nj-text">{c.title}</h1>
        <div className="mt-8 space-y-4 text-nj-text2 leading-relaxed">
          {c.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </Layout>
  );
}
